import { render } from "./BoardMenuDropdown.vue?vue&type=template&id=1a5fd418&scoped=true"
import script from "./BoardMenuDropdown.vue?vue&type=script&lang=js"
export * from "./BoardMenuDropdown.vue?vue&type=script&lang=js"

import "./BoardMenuDropdown.vue?vue&type=style&index=0&id=1a5fd418&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a5fd418"

export default script